import Swal from "sweetalert2";

const defaultOptions = {
  position: "center",
  allowOutsideClick: true,
};

const toast = {
  success: (message, options = {}) => {
    Swal.fire({
      ...defaultOptions,
      icon: "success",
      title: message,
      ...options,
    });
  },

  error: (message, options = {}) => {
    Swal.fire({
      ...defaultOptions,
      icon: "error",
      title: message,
      ...options,
    });
  },

  warn: (message, options = {}) => {
    Swal.fire({
      ...defaultOptions,
      icon: "warning",
      title: message,
      ...options,
    });
  },

  info: (message, options = {}) => {
    Swal.fire({
      ...defaultOptions,
      icon: "info",
      title: message,
      ...options,
    });
  },
};

export { toast };
export default toast;
